<!--
 * @Author: wjc
 * @Date: 2023-11-13 11:04:42
 * @LastEditors: wjc
 * @LastEditTime: 2023-12-11 15:16:40
 * @Description: 
-->
<template>
  <div class="m-content-menu">
    <template v-for="item in data" :key="item.id">
      <div
        :class="[current.id === item.id ? 'active' : '']"
        class="menu"
        @click="handleClick(item)"
      >
        {{ item.name }}
      </div>
    </template>
  </div>
</template>

<script setup lang="ts">
  import type { IInfo } from '~/models/activity'

  defineOptions({
    name: 'MContentMenu',
  })

  const props = withDefaults(
    defineProps<{
      data: IInfo[]
      current: IInfo
    }>(),
    {
      data: [],
    }
  )
  const emits = defineEmits<{
    (e: 'click', menu: IInfo): void
  }>()

  const handleClick = (menu: IInfo) => {
    emits('click', menu)
  }
</script>

<style scoped lang="scss">
  .m-content-menu {
    @apply md:block rounded-8px bg-white md:py-16px md:px-0 mb-24px;
    @screen lt-xs {
      @apply flex flex-justify-between w-full py-0px px-16px overflow-auto;
    }
    .menu {
      @apply relative text-color-1 font-s-18px px-30px py-20px hover:bg-bg-2 hover:text-primary-color cursor-pointer transition-250;
      @screen lt-xs {
        @apply flex-shrink-0;
      }
      &.active {
        @apply bg-bg-2 text-primary-color font-600 transition-background-color-250;
        &::before {
          @apply absolute left-0 md:bottom-auto md:top-0 inline-block md:h-full md:w-4px bg-bg-color transition-250;
          content: '';
          @screen lt-xs {
            @apply w-full h-4px bottom-0 top-auto;
          }
        }
      }
    }
  }
</style>
